import React, {useMemo} from "react";
import BigNumber from "bignumber.js";

import Modal from "../../Interface/Modal/Modal";
import Input from "../../Interface/Input/Input";
import Button from "../../Interface/Button/Button";

import {useEthereum} from "../../../EthereumContext";
import {useSelector} from "react-redux";
import {convertBalance} from "../../../utils";
import {toast} from "react-toastify";
import ProcessingLabel from "../../Interface/ProcessingLabel";
import useResize from "../../../hooks/useResize";

function UnstakingModal({isOpen, setIsOpen}) {
    const {staking} = useEthereum();

    const [amount, setAmount] = React.useState("");
    const [pending, setPending] = React.useState(false);

    const [showLoading, setShowLoading] = React.useState(false);
    const [status, setStatus] = React.useState("");

    const unlockedBalance = useSelector(store => store.staking.userUnlockedBalance);


    const showProcessingLoader = React.useCallback((status) => {
        setStatus(status);
        setShowLoading(true);
    }, [setShowLoading, setStatus]);

    const hideProcessingLoader = React.useCallback(() => {
        setStatus("");
        setShowLoading(false);
    }, [setShowLoading, setStatus]);

    const onUnstake = async () => {
        if (!amount) return;

        setPending(true);
        showProcessingLoader("Unstaking tokens");

        try {
            let realAmount = new BigNumber(amount);
            realAmount = realAmount.multipliedBy((new BigNumber(10)).pow(18));
            const gas = await staking.estimateGas.withdraw(realAmount.toFixed());
            const tx = await staking.withdraw(realAmount.toFixed(), {gasLimit: gas});
            await tx.wait();
            toast.info("Unstaking is completed");

            setIsOpen(false);
        } catch {
            toast.error("Unstaking failed");
        } finally {
            setPending(false);
            hideProcessingLoader();
        }
    };

    const { windowWidth } = useResize();

    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    return (
        <Modal
            title="Unstake Your Tokens"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            height={310}
        >
            <div>
                <ProcessingLabel
                    show={showLoading && status !== ""}
                    message={status}
                />
                <div style={
                    mobileView ?
                        {marginTop: 30, paddingLeft: 20, paddingRight: 20}
                        :
                        {marginTop: 40, paddingLeft: 100, paddingRight: 100}}
                >
                    <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
                        <span style={{color: "var(--grey0)"}}>Amount of ROOBEE</span>
                        <span
                            style={{color: "var(--grey0)", cursor: "pointer"}}
                            onClick={() => {
                                const bnBalance = new BigNumber(unlockedBalance.toString());
                                const divisor = (new BigNumber(10)).pow(18);
                                setAmount(bnBalance.div(divisor).toFixed());
                            }}
                        >
                            Max: {convertBalance(unlockedBalance)}
                        </span>
                    </div>
                    <Input
                        value={amount}
                        setValue={setAmount}
                        style={{marginTop: 5}}
                        placeholder="999.999,99"
                    />
                    <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: 40}}>
                        <Button className="highlightedButton" onClick={onUnstake} disabled={pending || unlockedBalance === '0'} blinking={pending}>
                            Unstake
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default UnstakingModal;
